export default __webpack_public_path__ + "static/media/A.f37af2b9.svg";